var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/Navigation/nav-arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94088 3.19064C5.11174 3.01979 5.38875 3.01979 5.5596 3.19064L9.0596 6.69064C9.23046 6.8615 9.23046 7.1385 9.0596 7.30936L5.5596 10.8094C5.38875 10.9802 5.11174 10.9802 4.94088 10.8094C4.77003 10.6385 4.77003 10.3615 4.94088 10.1906L8.13153 7L4.94088 3.80936C4.77003 3.6385 4.77003 3.3615 4.94088 3.19064Z",
    fill: "#374151"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrowLeft);
export default __webpack_public_path__ + "static/media/nav-arrow-left.0b31cc49997805261b9b2e7047b91a34.svg";
export { ForwardRef as ReactComponent };